import { createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-58e3c3de"),n=n(),_popScopeId(),n)
const _hoisted_1 = ["href"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("svg", {
    "aria-hidden": "true",
    class: _normalizeClass(_ctx.svgClass)
  }, [
    _createElementVNode("use", {
      href: '#icon-'+_ctx.iconName
    }, null, 8, _hoisted_1)
  ], 2))
}